import naja from 'naja';
import 'flowbite';

// Croppie importujeme a dáváme do window, kdyby ho někdo potřeboval globálně
import Croppie from 'croppie';
window.Croppie = Croppie;

// Naju dáme do window (pro Tracy bar a ladění)
window.naja = naja;

import { initAllPageComponents } from './page-ui.js';
import { configureNaja } from './naja-setup.js';

// 1. Nakonfigurujeme Naju (přidáme listenery)
configureNaja(naja);

// 2. Spustíme aplikaci, až bude DOM připraven
document.addEventListener('DOMContentLoaded', () => {
    console.log('🚀 Aplikace startuje...');

    naja.initialize();              // 1. Start Naji
    initAllPageComponents(document); // 2. První inicializace UI prvků

    console.log('🏁 Aplikace připravena.');
});